import { EditSubscriptionModal } from 'subscriptions-iframe-lib';
import { useSubscription } from '../../hooks/useSubscription';
import { jsx as _jsx } from "react/jsx-runtime";
export function EditModal({
  actions,
  refetchStaleData
}) {
  const {
    isOpen,
    close
  } = actions;
  const subscription = useSubscription();
  const onClose = () => {
    refetchStaleData();
    close();
  };
  if (!subscription || !subscription.internalId) {
    return null;
  }
  return /*#__PURE__*/_jsx(EditSubscriptionModal, {
    isOpen: isOpen,
    subscriptionId: subscription.internalId,
    onClose: onClose
  });
}